import './LinkifiedText.scss'

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Linkify from 'linkify-it'
import Link from '../Link'

const linkify = Linkify()

const LinkifiedText = props => {
  const text = props.text.trim()
  const simpleText = (<span>{text}</span>)
  if (!linkify.pretest(text)) {
    return simpleText
  }

  // pretest() is a fast test, but may have false positives
  const matches = linkify.match(text)
  if (!matches) {
    return simpleText
  }

  const textParts = matches
    .map((currentLinkMatch, i) => {
      const textStart = i === 0 ? 0 : matches[i-1].lastIndex
      return [
        text.substr(textStart, currentLinkMatch.index - textStart),
        <Link target='_blank' href={currentLinkMatch.url} title={currentLinkMatch.url}>{currentLinkMatch.text}</Link>
      ]
    })

  const trailingText = text.substr(matches[matches.length-1].lastIndex)
  textParts.push(trailingText)

  return (<span>{textParts}</span>)
}

LinkifiedText.defaultProps = {
  text: '',
}

LinkifiedText.propTypes = {
  text: PropTypes.string,
}

export default LinkifiedText



// WEBPACK FOOTER //
// ./src/components/LinkifiedText/LinkifiedText.js